import { WKTObject } from '../WKTObject';
import { Omrade } from './Omrade';

export class Land extends Omrade {
    declare readonly kartutsnitt: WKTObject;

    constructor(
        readonly navn: string,
        kartutsnitt: WKTObject
    ) {
        super(navn, null, kartutsnitt, null, null);
    }

    override(modifyObject: { [P in keyof Land]?: Land[P] }): Land {
        return Object.assign(Object.create(Land.prototype), { ...this, ...modifyObject });
    }

    toString(): string {
        return this.navn;
    }

    getAreaType(): string {
        return 'Land';
    }

    toParams(): undefined {
        return undefined;
    }

    withVisible(visible: boolean): Land {
        return this.override({ visible });
    }
}
